function validateComment(event) {
  commentBodyValue = event.target.value
  maxInputLength = 65535

  $parentForm = $(event.target).parents('form')
  $limitExceededElement = $parentForm.find('#character-limit-exceeded')

  if (commentBodyValue.length > maxInputLength) {
    $limitExceededElement.addClass("with-error")

    exceedingCount = (commentBodyValue.length - maxInputLength)
    error_translation = I18n.t('activerecord.errors.shared.exceeding_characters_with_attribute',
      { count: exceedingCount, attribute: I18n.t('activerecord.attributes.comment.body')}
    )
    $limitExceededElement.html(error_translation)
  } else {
    $limitExceededElement.removeClass("with-error")
  }

  isSubmitButtonDisabled = commentBodyValue.length === 0 || commentBodyValue.length > maxInputLength
  $parentForm.find("input[type='submit']").prop('disabled', isSubmitButtonDisabled)
}

$(document).on('turbolinks:load', function() {
  $(document).on('input', '#comment_body', validateComment)
})
